import {
  FETCH_COMPANIES_REQUEST,
  FETCH_COMPANIES_SUCCESS,
  FETCH_COMPANIES_FAILURE,
} from '../actions/actionTypes';
import { CompaniesAction } from '../actions/companiesActions';

export interface CompaniesState {
  companies: { id: string; name: string }[];
  companiesWithOpenings: any[];
  /** The full list (`fetchAllCompanies`), loaded only when a work-experience editor opens. */
  allLoading: boolean;
  allLoaded: boolean;
  allError: string | null;
  /** Companies with open roles (`fetchCompaniesWithOpenings`). */
  openingsLoading: boolean;
  openingsLoaded: boolean;
  openingsError: string | null;
}

export const initialCompaniesState: CompaniesState = {
  companies: [],
  companiesWithOpenings: [],
  allLoading: false,
  allLoaded: false,
  allError: null,
  openingsLoading: false,
  openingsLoaded: false,
  openingsError: null,
};

export default function companiesReducer(
  state = initialCompaniesState,
  action: CompaniesAction
): CompaniesState {
  switch (action.type) {
    case FETCH_COMPANIES_REQUEST:
      return action.part === 'all'
        ? { ...state, allLoading: true, allError: null }
        : { ...state, openingsLoading: true, openingsError: null };
    case FETCH_COMPANIES_SUCCESS:
      return action.part === 'all'
        ? { ...state, allLoading: false, allLoaded: true, companies: action.payload.companies ?? [] }
        : { ...state, openingsLoading: false, openingsLoaded: true, companiesWithOpenings: action.payload.companiesWithOpenings ?? [] };
    case FETCH_COMPANIES_FAILURE:
      return action.part === 'all'
        ? { ...state, allLoading: false, allError: action.payload }
        : { ...state, openingsLoading: false, openingsError: action.payload };
    default:
      return state;
  }
}
